import React from 'react';
import {
  ProductTransactionStatusContext,
  ProductTransactionStatusContextProps,
} from '../context/ProductTransactionStatusContext';
import { ProductTransactionStatus } from '../types/order/productTransactionStatus';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { v4 } from 'uuid';

const productTransactionStatusState = {
  items: new Map<string, ProductTransactionStatus>(),
  loading: false,
};

interface ProductTransactionStatusState {
  key: string;
}

export const productTransactionStatusSlice = createSlice({
  name: 'productTransactionStatus',
  initialState: { key: v4() } as ProductTransactionStatusState,
  reducers: {
    reset: state => {
      productTransactionStatusState.items = new Map();
      productTransactionStatusState.loading = true;
      state.key = v4();
    },
    set: (state, action: PayloadAction<ProductTransactionStatus[]>) => {
      productTransactionStatusState.items = new Map();
      action.payload.forEach(pts => productTransactionStatusState.items.set(pts.id, new ProductTransactionStatus(pts)));
      state.key = v4();
    },
    add: (state, action: PayloadAction<ProductTransactionStatus[]>) => {
      action.payload.forEach(pts => productTransactionStatusState.items.set(pts.id, new ProductTransactionStatus(pts)));
      productTransactionStatusState.items = new Map(productTransactionStatusState.items);
      state.key = v4();
    },
    delete: (state, action: PayloadAction<ProductTransactionStatus[]>) => {
      action.payload.forEach(pts => productTransactionStatusState.items.delete(pts.id));
      productTransactionStatusState.items = new Map(productTransactionStatusState.items);
      state.key = v4();
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      productTransactionStatusState.loading = action.payload;
      state.key = v4();
    },
  },
});

interface ProductTransactionStatusProviderProps {
  children: React.ReactNode;
}

export default function ProductTransactionStatusProvider({ children }: ProductTransactionStatusProviderProps) {
  const dispatch = useAppDispatch();
  const key = useAppSelector(state => state.productTransactionStatuses.key);

  const productTransactionStatusContext: ProductTransactionStatusContextProps = {
    productTransactionStatuses: productTransactionStatusState.items,
    productTransactionStatusesLoading: productTransactionStatusState.loading,
    setProductTransactionStatuses: (productTransactionStatuses: Map<string, ProductTransactionStatus>) => {
      dispatch(productTransactionStatusSlice.actions.set([...productTransactionStatuses.values()]));
    },
  };

  return (
    <ProductTransactionStatusContext.Provider value={productTransactionStatusContext}>
      {children}
    </ProductTransactionStatusContext.Provider>
  );
}
